import { useEffect, useState } from 'react';
import { prizeList } from '@/config';
import { goDoc } from '@/utils'
import { getMyPrize } from '@/api';
import styles from './index.module.scss';

function MyPrize(props) {
  const [prizeArr, setPrizeArr] = useState([]);
  const [errorTips, setErrorTips] = useState("");
  useEffect(() => {
    getMyPrize().then(res => {
      const prizeArr = []
      if(res.length) {
        res.forEach(item => {
          const { imgIndex = 4, desc = '' } = prizeList[item.prize] || {}
          prizeArr.push({ imgIndex, desc, prizeIndex: item.prize })
        });
      }
      setPrizeArr(prizeArr)
    }).catch((res) => {
      setErrorTips(res.msg);
      setTimeout(() => setErrorTips(""), 2000)
    })
  }, [])
  const tapPrize = prizeIndex => {
    if(prizeIndex === 5) {
      return goDoc()
    }
  }

  return (
    <div className={[styles.myPrize, props.className].join('\x20')}>
      <div className={styles.myPrizeMain}>
        <div className={styles.header}>
          我的奖品
          <i onClick={() => props.onClick()}></i>
        </div>
        <ul className={styles.prizeList}>
          {
            prizeArr.map(({ imgIndex, desc, prizeIndex }, index) => (
              <li key={ prizeIndex + '-prize-' + index }>
                { prizeIndex === 5 ? <div className={styles.claimNow} onClick={() => tapPrize(prizeIndex)}>立即领取</div> : '' }
                <div className={['prize-prod', 'prize-prod-' + imgIndex, styles.prodImg].join('\x20')}></div>
                <div className={styles.prodDesc}>{ desc }</div>
              </li>
            ))
          }
          {
            prizeArr.length ? '' : (<li className={styles.noPrize}>您暂未获得奖品</li>)
          }
        </ul>
        <p className={styles.myPrizeTips}>获得实物奖的用户将在活动结束3日内收到短信，请及时查看</p>
        {
          errorTips ? (<p className={styles.errorTips}>{errorTips}</p>) : ""
         }
      </div>
    </div>
  )
}

export default MyPrize;
